import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import {
  ListItem,
  ADPResourceService as ResourceService,
} from "digital-core";


@Component({
  selector: 'gsp-button-toggle-filter',
  templateUrl: './button-toggle-filter.component.html',
  styleUrls: ['./button-toggle-filter.component.scss']
})
export class ButtonToggleFilterComponent implements OnInit {


  get resource() {
    return this.resourceService;
  }

  @Input() deviceTypeToggle: ListItem[] = [];
  @Input() coverageType: string;
  @Input() initialValue: string;
  @Input() enableAllFilter: boolean = false;
  @Output() changeSelectionExtension: EventEmitter<{ controlName: any, controlValue: any, coverageType: any }> = new EventEmitter<{ controlName: any, controlValue: any, coverageType: any }>();

  constructor(
    private resourceService: ResourceService,
  ) { }

  ngOnInit() {
  }

  onChange(controlName: any, controlValue: any, coverageType: any) {
    this.changeSelectionExtension.emit({ controlName, controlValue, coverageType });
  }
}